import { useState } from 'react';
import { useNavigate } from 'react-router';
import ArrowsLine from '../../assets/icons/ArrowsLine';
import Button from '../../components/ui/Button';
import Gallery from '../../components/ui/Gallery';
import Tag from '../../components/ui/Tag';
import { AssetType, RootPathes } from '../../types';
import { useQuery } from '@tanstack/react-query';
import { getAssets } from '../../api/assets';

const AssetsTab = () => {
  const navigate = useNavigate();
  const [filter, setFilter] = useState('all');

  const goToData = (path: string) => navigate(path);

  const { data, isPending } = useQuery({
    queryKey: ['assets', filter],
    queryFn: () => getAssets({ page: 1, limit: 100, asset_type: filter }), // TODO: think about pagination on scroll
    staleTime: 1000 * 30,
  });

  const assets = data?.results.results || [];

  return (
    <div className='mt-[20px] flex h-full flex-col justify-between space-y-6'>
      <div className='space-y-6'>
        <div className='flex flex-col font-medium'>
          <h2 className='text-lg text-white'>Your Assets:</h2>

          <span className='text-xs text-coral-2'>
            {isPending
              ? 'Loading...'
              : assets.length === 0
                ? `You haven’t ${
                  filter === 'all' ? 'any' : filter
                } any dataset assets yet.`
                : `You have ${assets.length} assets`}
          </span>

          <div className='scrollbar-hide mt-2 flex w-full flex-row gap-2 overflow-x-auto p-1'>
            {Object.values(AssetType).map((type, index) => (
              <Tag
                key={index}
                text={type}
                active={type.toLowerCase() === filter}
                setFilter={setFilter}
              />
            ))}
          </div>
        </div>

        {!isPending && (
          <Gallery
            items={assets}
            onAdd={filter === 'media' ? () => goToData(RootPathes.NEW_ASSET) : undefined}
          />
        )}
      </div>

      <div className='mt-auto flex'>
        <Button
          onClick={() => goToData(RootPathes.NEW_ASSET)}
          variant='solid'
          iconBack={<ArrowsLine color='currentColor' />}
        >
          Create media asset
        </Button>
      </div>
    </div>
  );
};

export default AssetsTab;
